(()=>{
 const init=()=>{
  const arrow=document.querySelector('.se-mobile-page-back');
  if(!arrow)return;
  const parent=()=>{
   const url=new URL(location.href);
   if(url.searchParams.has('quilt_folder')||url.searchParams.has('tablecloth_folder')){
    url.searchParams.delete('quilt_folder');url.searchParams.delete('tablecloth_folder');url.hash='';return url.pathname+url.search;
   }
   const path=location.pathname;
   if(path.includes('/blogs/')&&path.split('/').filter(Boolean).length>2)return path.split('/').slice(0,3).join('/');
   if(path.endsWith('/pages/handmade-copper-bathtubs'))return '/pages/bathroom';
   if(path.includes('/collections/')){
    const handle=path.split('/collections/')[1].split('/')[0];
    if(['cotton-throws','velvet-suzani-throws'].includes(handle))return '/collections/throws';
    if(/lighting|chandelier|ceiling-lights|outdoor-lights/.test(handle)&&!['lighting','designer-lighting'].includes(handle))return '/collections/lighting';
    if(['lighting','designer-lighting'].includes(handle))return '/';
    return '/collections';
   }
   return '/';
  };
  const update=()=>{
   arrow.href=parent();
   const folderBack=document.querySelector('.sq-back:not([hidden]),.tc-back:not([hidden])');
   arrow.classList.toggle('se-folder-back-active',Boolean(folderBack));
   document.querySelectorAll('.sq-back,.tc-back').forEach(back=>{
    back.classList.add('se-subfolder-back');
    if(!back.querySelector('svg')){
     const label=document.createElement('span');label.className='se-subfolder-back-label';label.textContent=back.textContent;back.replaceChildren(label);
     back.insertAdjacentHTML('afterbegin','<svg viewBox="0 0 24 24" width="22" height="22" fill="none" aria-hidden="true"><path d="M19 12H5m6-6-6 6 6 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
     back.setAttribute('aria-label',back.classList.contains('sq-back')?'Back to Quilts':'Back to Tablecloths');
    }
   });
  };
  update();
  arrow.addEventListener('click',event=>{
   if(event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
   const folderBack=document.querySelector('.sq-back:not([hidden]),.tc-back:not([hidden])');
   if(folderBack){event.preventDefault();folderBack.click();update();return;}
   let internal=false;
   try{internal=new URL(document.referrer).origin===location.origin;}catch{}
   if(internal&&history.length>1){event.preventDefault();history.back();}
  });
  window.addEventListener('popstate',()=>requestAnimationFrame(update));
  document.addEventListener('click',event=>{if(event.target.closest('[data-quilt-folder],[data-tablecloth-folder],.sq-back,.tc-back'))requestAnimationFrame(update);});
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();